<Router>
  
  <Route path="/auth/action" platform={platform} component={SetPassword} let:params/>
  
  {#if !isLoggedIn}
    <Route exact path="/auth/forgot">
      <Forgot platform={platform} />
    </Route>
    <Route exact path="/">
      <Header 
        on:logout={logout}
        platformName={platform}
      >
        <div slot="skip-to-content">
          <SkipToContent />
        </div>
      </Header>
      
      <Content>
        <Login on:loggedIn={loggedIn}/>
      </Content>
    </Route>
    <Route path="*" component={NotFound}/>

  {:else}

    <Header 
      on:logout={logout}
      persistentHamburgerMenu={true}
      company={clientName}
      platformName={platform}
      bind:isSideNavOpen
    >
      <div slot="skip-to-content">
        <SkipToContent />
      </div>

      <HeaderUtilities>
        <HeaderGlobalAction aria-label="Notifications" icon="{Notification20}" />
        <HeaderGlobalAction aria-label="User Avatar" icon="{UserAvatar20}" on:click={(e)=>logout(e)} />
        <HeaderGlobalAction aria-label="Settings" icon={SettingsAdjust20} />
        <HeaderAction bind:isOpen>
          <HeaderPanelLinks>
            <HeaderPanelDivider>Switcher subject 1</HeaderPanelDivider>
            <HeaderPanelLink>Switcher item 1</HeaderPanelLink>
            <HeaderPanelDivider>Switcher subject 2</HeaderPanelDivider>
            <HeaderPanelLink>Switcher item 1</HeaderPanelLink>
            <HeaderPanelLink>Switcher item 2</HeaderPanelLink>
            <HeaderPanelLink>Switcher item 3</HeaderPanelLink>
            <HeaderPanelLink>Switcher item 4</HeaderPanelLink>
            <HeaderPanelLink>Switcher item 5</HeaderPanelLink>
          </HeaderPanelLinks>
        </HeaderAction>
      </HeaderUtilities>
    </Header>

    <SideNav bind:isOpen={isSideNavOpen}>
      <SideNavItems>
        <ClientDropdown />
      </SideNavItems>
    </SideNav>

    <Content>
      <Router>
        <Route exact path="/" component={Markers} let:params/>
        <Route path="/marker/:id/:snp" let:params>
          <Marker id="{params.id}" snp="{params.snp}"/>
        </Route>
        <Route path="*" component={NotFound}/>
      </Router>
    </Content>

  {/if}

</Router>

<style lang="scss" global>
	/** Gray 10 theme **/
	@import "carbon-components-svelte/css/g10";
  @import '@carbon/colors/scss/mixins';
  @include carbon--colors();
  .float-left {
    float: left;
  }
  .float-right {
    float: right;
  }
</style>

<script>
	export let platform

  import { onDestroy } from 'svelte'
  import { Router, Route, Link, navigate } from 'svelte-routing'
  import { currentUser } from './helpers/stores.js'
	import auth from './helpers/auth.js'

	// App Components
	import ClientDropdown from './components/clients/Dropdown.svelte'
  import Markers from './components/tables/Markers.svelte'
  import Marker from './components/markers/Container.svelte'
  import Login from './components/auth/Login.svelte'
  import Forgot from './components/auth/Forgot.svelte'
  import SetPassword from './components/auth/SetPassword.svelte'
	import NotFound from './pages/404.svelte'

	// Native Carbon Components
	import {
    Header,
    HeaderNav,
    HeaderNavItem,
		HeaderNavMenu,
		HeaderUtilities,
    HeaderAction,
    HeaderGlobalAction,
    HeaderPanelLinks,
    HeaderPanelDivider,
    HeaderPanelLink,
		SkipToContent,
		SideNav,
    SideNavItems,
    SideNavMenu,
    SideNavMenuItem,
    SideNavLink,
    Content,
  } from "carbon-components-svelte"
	import SettingsAdjust20 from "carbon-icons-svelte/lib/SettingsAdjust20" 
	import Notification20 from "carbon-icons-svelte/lib/Notification20"
  import UserAvatar20 from "carbon-icons-svelte/lib/UserAvatar20"
	import AppSwitcher20 from "carbon-icons-svelte/lib/AppSwitcher20"

	let isSideNavOpen = false
	let isOpen = false

	let authStore
	let unsubscribe = auth.subscribe(store => {
    	authStore = store
	})
	
	$: isLoggedIn = authStore.loggedIn	
	$: isAdmin = authStore.isAdmin
  $: clientID = authStore.clientID
  $: clientName = authStore.clientName

  onDestroy(() => {
    if (unsubscribe) {
      unsubscribe()
		}
  })
  	
	const logout = (e) => {
		currentUser.set(false)
    auth.logout()
		navigate(`/`, {replace: true})
	}

	const loggedIn = (e) => {
		currentUser.set(isLoggedIn)
    navigate(`/`)
	}
	
</script>